@if(!showEdit){
<div class="main-container">
  <div class="title">
    <span class="title-text">Manage Visitors</span>
    <p class="small-title">Enter family code to proceed with the search.</p>
  </div>

  <form [formGroup]="searchForm" (ngSubmit)="searchByFamilyCode()">
    <div class="searchBar">
      <input type="text" maxlength="12" class="searchInput ac-input-control" placeholder="Enter family code"
        formControlName="familyCode" />

      <div class="btn">
        <button type="button" class="ac-secondary-btn" (click)="reset()">
          Reset
        </button>
        <button type="submit" class="ac-primary-btn" [disabled]="searchForm.invalid">
          Search
        </button>
      </div>
    </div>
  </form>

  <!-- @if(profileList.length > 0){
  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr>
          <th>Name</th>
          <th>Gender</th>
          <th>Family Code</th>
          <th>Mobile Number</th>
          <th>Aadhaar Number</th>
          <th>Status</th>
        </tr>
      </thead>

      <tbody class="table-body">
        @for(row of profileList; track row){
        <tr (click)="onRowClick(row)">
          <td>
            {{row.devoteeFirstName}} {{row.devoteeMiddleName || ''}}
            {{row.devoteeLastName}}
          </td>
          <td>{{row.gender}}</td>
          <td>{{row.devoteeFamilyCode}}</td>
          <td>{{row.mobileNumber}}</td>
          <td>{{row.idNumber}}</td>
          <td>{{row.status}}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }  -->
  
  @if(profileList.length > 0){

  @if(!isMobile){
  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr>
          <th>Name</th>
          <th>Gender</th>
          <th>Family Code</th>
          <th>Mobile Number</th>
          <th>Aadhaar Number</th>
          <th>Status</th>
        </tr>
      </thead>

      <tbody class="table-body">
        @for(row of profileList; track row){
        <tr (click)="onRowClick(row)">
          <td>
            {{row.devoteeFirstName}} {{row.devoteeMiddleName || ''}}
            {{row.devoteeLastName}}
          </td>
          <td>{{row.gender}}</td>
          <td>{{row.devoteeFamilyCode}}</td>
          <td>{{row.mobileNumber}}</td>
          <td>{{row.idNumber}}</td>
          <td>{{row.status}}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  @if(isMobile){
  <div class="mobile-card-list">
    @for(row of profileList; track row){
    <div class="mobile-card" (click)="onRowClick(row)">
      
      <div class="mc-name">
        {{row.devoteeFirstName}} {{row.devoteeMiddleName || ''}} {{row.devoteeLastName}}
      </div>

      <div class="mc-row">
        <span class="mc-label">Gender</span>
        <span class="mc-value">{{row.gender}}</span>
      </div>

      <div class="mc-row">
        <span class="mc-label">Family Code</span>
        <span class="mc-value">{{row.devoteeFamilyCode}}</span>
      </div>

      <div class="mc-row">
        <span class="mc-label">Mobile</span>
        <span class="mc-value">{{row.mobileNumber}}</span>
      </div>

      <div class="mc-row">
        <span class="mc-label">Aadhaar</span>
        <span class="mc-value">{{row.idNumber}}</span>
      </div>

      <div class="mc-row">
        <span class="mc-label">Status</span>
        <span class="mc-value">{{row.status}}</span>
      </div>

    </div>
    }
  </div>
  }

}@else {
  <div class="list-div">
    <div class="img-div">
      <img style="width: 150px;" src="icons/search_placeholder_dark.png" alt="">
      <span class="drop-title" style="text-align: end;">No Data Found</span>
    </div>
  </div>
  }
</div>
} @else {
<div class="main-container">
  <div class="title">
    <span class="back-btn" style="color: var(--brand-primary); cursor:pointer" (click)="back()">
       <img src="icons/back-arrow-icon.svg" style="height: 15px; width: 15px;">
      Go back
    </span>
    <span class="title-text">
      Visitors list of {{ primaryMemberName }}-{{primaryFC}}
    </span>
  </div>

  <div class="card-details">
    @for(item of profileDetails; track item) {

    <div class="family-details">

      <!-- NAME ROW -->
      <div class="details">
        <div class="name-row">
          <span class="common-text">
            {{ item.fullName }}
          </span>
        </div>
      </div>

       <!-- GENDER -->
      <div class="details">
        <span class="common-header">Gender</span>
        <span class="common-text">{{ item.gender }}</span>
      </div>

      <!-- RELATIONSHIP -->
      <div class="details">
        <span class="common-header">Relationship</span>
        <span class="common-text">{{ item.relationship }}</span>
      </div>

       <!-- FC -->
      <!-- <div class="details">
        <span class="common-header">FamilyCode</span>
        <span class="common-text">{{ item.familyCode }}
           <img src="icons/edit-line.png" class="edit-icon" alt="edit" (click)="editAadhaar(item)" />
            <img src="icons/delete-bin.png" class="edit-icon" alt="edit" (click)="editAadhaar(item)" />

        </span>
      </div> -->
      <div class="details">
        <span class="common-header">FamilyCode</span>
        <span class="common-text">
          {{ item.familyCode }}
            <img src="icons/edit-line.png" class="edit-icon" alt="edit" (click)="editFC(item)"/>
          <button class="icon-btn delete-btn" (click)="deleteFamilyCode(item)" title="Delete">
            <img src="icons/delete-bin.png" class="action-icon" alt="delete" />
          </button>
        </span>
      </div>

        <!-- Name -->
      <div class="details">
        <span class="common-header">Name</span>
        <span class="common-text">{{ item.fullName }}
         @if(!item.familyCode){
         <img src="icons/edit-line.png" class="edit-icon" alt="edit" (click)="editVisitorName(item)" />
         }
         </span>
      </div>


        <!-- MOBILE -->
      <div class="details">
        <span class="common-header">Mobile</span>
        <span class="common-text">{{ item.mobileNumber }}</span>
      </div>

      <!-- AADHAAR -->
      <div class="details">
        <span class="common-header">Aadhaar</span>
        <span class="common-text">
          {{ item.aadharNumber }}
          <img src="icons/edit-line.png" class="edit-icon" alt="edit" (click)="editAadhaar(item)" />
        </span>
      </div>

    </div>

    }
  </div>






</div>
}